import { Inject, Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MacUserService } from '../user/mac-user.service';
import { Observable } from 'rxjs';
import { map, skip } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
    constructor(
        private router: Router,
        @Inject('UserService') public user: MacUserService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        // do some checks here
        return this.user.watch.pipe(
            map(user => {
                if (!user || !user.loggedIn) {
                    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                    return false;
                }

                if (route.data.roles && !this.user.isGranted(route.data.roles)) {
                    this.router.navigate(['/']);
                    return false;
                }

                return true;
            }),
        );
    }
}
